module.exports = __webpack_public_path__ + "media/icons/szkody-pojazdu-1386813e.png";